var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LocalLookupService } from "../core/LocalLookupService";
import Config from "../../config";
const { DEFAULT_PAGE_SIZE } = Config;
export class CommsTypesService {
    constructor(whistleblower) {
        this.lookup = new LocalLookupService("activityCommsTypes");
        this.whistleblower = whistleblower;
    }
    getAll(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let results = yield this.lookup.getAll(params);
                if (this.whistleblower) {
                    let filteredData = results.data.filter((x) => x.whistleblower);
                    results = this.pageData(filteredData, params);
                }
                return Promise.resolve(results);
            }
            catch (e) {
                return Promise.reject(e);
            }
        });
    }
    get(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.lookup.get(id);
        });
    }
    pageData(baseData, { page } = {}) {
        const totalCount = baseData.length;
        return page !== undefined
            ? {
                data: baseData.slice(page * DEFAULT_PAGE_SIZE, page * DEFAULT_PAGE_SIZE + DEFAULT_PAGE_SIZE),
                totalCount,
                page,
                totalPages: Math.ceil(totalCount / DEFAULT_PAGE_SIZE),
                pageSize: DEFAULT_PAGE_SIZE,
            }
            : {
                data: baseData,
                totalCount,
            };
    }
}
